<template>
    <div>
        <app-template>
            <div class="bg-slate-50 min-h-screen py-12">
                <div class="max-w-4xl mx-auto px-6">

                    <!-- HEADER -->
                    <div class="bg-white rounded-xl shadow-sm border p-8 mb-8">
                        <h1 class="text-3xl font-bold text-gray-900 mb-4">
                            Expiration de licence : que se passe-t-il ?
                        </h1>
                        <p class="text-gray-600 text-lg leading-relaxed">
                            Votre licence garantit l’accès complet à votre espace professionnel, à vos données et à l’ensemble des fonctionnalités de la plateforme.
                            Lorsqu’elle expire, votre espace est temporairement suspendu, limitant l’accès à vos contrats, interventions et documents. Pas d’inquiétude : vos données restent sécurisées et une simple régularisation permet de réactiver instantanément votre accès.
                        </p>
                    </div>

                    <!-- QUE SE PASSE-T-IL -->
                    <div class="bg-white rounded-xl shadow-sm border p-8 mb-8">
                        <h2 class="text-2xl font-semibold text-gray-900 mb-6">
                            Que se passe-t-il concrètement ?
                        </h2>

                        <ul class="space-y-4 text-gray-700 leading-relaxed">
                            <li class="flex gap-3">
                                <i class="fas fa-times-circle text-red-500 mt-1"></i>
                                <span>Vous n'avez plus accès à votre espace de travail.</span>
                            </li>

                            <li class="flex gap-3">
                                <i class="fas fa-lock text-red-500 mt-1"></i>
                                <span>L’accès à votre tableau de bord et à vos données est temporairement suspendu.</span>
                            </li>

                            <li class="flex gap-3">
                                <i class="fas fa-database text-red-500 mt-1"></i>
                                <span>Vos données restent sécurisées et conservées.</span>
                            </li>
                        </ul>

                        <div class="mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                            <p class="text-blue-900 text-sm">
                                Bonne nouvelle : aucune suppression immédiate n’est effectuée. Une simple régularisation permet de réactiver instantanément votre accès.
                            </p>
                        </div>
                    </div>

                    <!-- POURQUOI -->
                    <div class="bg-white rounded-xl shadow-sm border p-8">
                        <h2 class="text-2xl font-semibold text-gray-900 mb-6">
                            Pourquoi une licence peut-elle expirer ?
                        </h2>

                        <div class="space-y-5 text-gray-700 leading-relaxed">
                            <div class="flex gap-3">
                                <i class="fas fa-credit-card text-gray-500 mt-1"></i>
                                <span>
                                    <strong>Absence ou échec de paiement :</strong>
                                    la raison la plus fréquente (carte expirée, prélèvement refusé, changement de moyen de paiement).
                                </span>
                            </div>

                            <div class="flex gap-3">
                                <i class="fas fa-hourglass-end text-gray-500 mt-1"></i>
                                <span>
                                    <strong>Fin de période d’essai :</strong>
                                    si aucun abonnement n’est activé après la phase de test.
                                </span>
                            </div>

                            <div class="flex gap-3">
                                <i class="fas fa-user-times text-gray-500 mt-1"></i>
                                <span>
                                    <strong>Demande volontaire de résiliation :</strong>
                                    suite à une clôture de compte initiée par votre société.
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </app-template>
    </div>
</template>

<script>
    export default {
        name: 'LicenceExpiration',
        data() {
            return {
    
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>